/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover, Tag } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ResponsiveComponent } from '../../../utils/functions';
import TableColumnSearch from '../../../components/Input/TableColumnSearch';
import Sidebar from '../../../components/Sidebar';
import { CustomTable } from '../../../components/Table';
import { plusicon, refreshicon } from '../../../components/imagepath';
import Header from '../../../components/Header';
import {
    ActionDeleteDietPlan,
    ActionGetDietPlanList,
} from '../../../store/Actions/MasterDataAction';
import { matchPermissions } from '../../../utils/Permission';
import { PERMISSIONS } from '../../../constants';


const { confirm } = Modal;

const DietPlan = () => {
    const { loader, dietPlan } = useSelector(state => state?.MasterData);
    const { userDetails } = useSelector(state => state?.auth);
    const [showArrow, setShowArrow] = useState(true);
    const [Refresh, setRefresh] = useState(false);
    const [arrowAtCenter, setArrowAtCenter] = useState(false);
    const pageSize = 10;
    const dispatch = useDispatch();
    const location = useLocation();
    const params = queryString.parse(location.search);
    const Size = ResponsiveComponent();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    const mergedArrow = useMemo(() => {
        if (arrowAtCenter)
            return {
                pointAtCenter: true,
            };
        return showArrow;
    }, [showArrow, arrowAtCenter]);

    const handleSearch = (selectedKeys, dataIndex) => {
        setSearchText(selectedKeys?.[0]);
        setSearchedColumn(dataIndex);

        if (params[dataIndex]) {
            window.location.replace(`/diet-plan?page=1&filterlist=true&${dataIndex}=${selectedKeys?.[0]}`);
        } else {
            window.location.replace(`/diet-plan?${location.search}&${dataIndex}=${selectedKeys?.[0]}`);
        }
    };

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('');
        window.location.replace(`/diet-plan`);
    };

    const matchPermissionsForUser = matchPermissions(userDetails);
    const canView = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.DIET_PLAN.VIEW);
    const canUpdate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.DIET_PLAN.UPDATE);
    const canDelete = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.DIET_PLAN.DELETE);
    const canCreate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.DIET_PLAN.CREATE);


    const content = item => (
        <div className="">
            {canUpdate && (
                <Button className="m-2" onClick={() => EditList(item?.id)}>
                    Edit
                </Button>
            )}
            {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
        </div>
    );

    const column = [
        {
            title: 'Sr',
            dataIndex: 'sr',
            render: (text, record, index) => {
                const currentPage = parseInt(params?.page) || 1;
                const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
                return <span>{calculatedIndex}</span>;
            },
        },
        {
            title: 'Diet Name',
            dataIndex: 'dietName',
            render: (text, record) => <span style={{ fontWeight: '500' }}>{record.dietName}</span>,
            ...TableColumnSearch({
                dataIndex: 'dietName',
                setSearchText,
                setSearchedColumn,
                handleReset,
                handleSearch,
            }),
        },
        {
            title: 'Status',
            dataIndex: 'isActive',
            render: (text, record) => (
                <Tag color={record.isActive ? 'green' : 'red'}>
                    {record.isActive ? 'Active' : 'Inactive'}
                </Tag>
            ),
        },
        {
            title: !canUpdate && !canDelete ? null : 'Action',
            dataIndex: 'id',
            key: 'action',
            render: (text, record, num) => {
                if (!canUpdate && !canDelete) {
                    return null;
                } else {
                    return (
                        <Popover
                            placement="left"
                            title={record.title}
                            content={() => content(record)}
                            arrow={mergedArrow}
                        >
                            <Button type="dashed">• • •</Button>
                        </Popover>
                    );
                }
            },
        },
    ];

    useEffect(() => {
        dispatch(ActionGetDietPlanList({ Query: `?page=${params?.page || 1}` }));
        setRefresh(false);
    }, [dispatch, params?.page, Refresh]);

    const handleSearch1 = searchTerm => {
        var newp = params;
        newp.page = searchTerm;
        window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
    };

    const EditList = searchTerm => {
        window.location.href = `/diet-plan/add-diet-plan?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
    };

    const showDeleteConfirm = item => {
        confirm({
            title: `Are you sure you want to delete "${item?.dietName}"?`,
            icon: <ExclamationCircleFilled />,
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            zIndex: 1200,
            centered: true,
            onOk() {
                dispatch(
                    ActionDeleteDietPlan('/' + item?.id, Res => {
                        if (Res === 200) {
                            setRefresh(true);
                        }
                    })
                );
            },
            onCancel() {
                return;
            },
        });
    };

    return (
        <>
            <Header />
            <Sidebar />
            <>
                <div>
                    <div className="page-wrapper">
                        <div className="content">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/diet-plan">Diet Plan</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <i className="feather-chevron-right">
                                                    <FeatherIcon icon="chevron-right" />
                                                </i>
                                            </li>
                                            <li className="breadcrumb-item active">Diet Plan List</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table show-entire">
                                        <div className="card-body">
                                            {/* Table Header */}
                                            <div className="page-table-header mb-2">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <div className="doctor-table-blk">
                                                            <h3>Diet Plan Master</h3>
                                                            <div className="doctor-search-blk">
                                                                <div className="add-group">
                                                                    {canCreate && (
                                                                        <Link
                                                                            to="/diet-plan/add-diet-plan"
                                                                            className="btn btn-primary add-pluss ms-2"
                                                                        >
                                                                            <img src={plusicon} alt="#" />
                                                                        </Link>
                                                                    )}

                                                                    <Link
                                                                        onClick={() => window.location.reload()}
                                                                        className="btn btn-primary doctor-refresh ms-2"
                                                                    >
                                                                        <img src={refreshicon} alt="#" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Table Header */}
                                            {canView ? (
                                                <CustomTable
                                                    CurrentPageNum={parseInt(params?.page) || 1}
                                                    OnChange={v => {
                                                        handleSearch1(v);
                                                    }}
                                                    TotalPageList={dietPlan?.totalDocs}
                                                    column={column}
                                                    dataSource={dietPlan?.docs}
                                                    dataSourceLength={dietPlan?.docs?.length}
                                                    pageSize={10}
                                                    loader={loader}
                                                    ShowHeader={true}
                                                    Header={<div className="staff-search-table"></div>}
                                                    key={'diet-plan-table'}
                                                />
                                            ) : (
                                                <div className="permission-denied-message">
                                                    You do not have permission to view the diet plans.
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};

export default DietPlan;
